module.exports = __webpack_public_path__ + "img/mb_ln_icon_en.8f98fc2e.png";